import React from 'react';
import PublicCmsPage from 'components/PublicCmsPage';

const TermsConditions = () => {
  return <PublicCmsPage />;
};

export default TermsConditions;
